module.exports = __webpack_public_path__ + "static/media/checkmark.86a30c4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkmark.svg
// module id = 243
// module chunks = 0